'use strict';

/**
 * @ngdoc service
 * @name courseApp.ConfigService
 * @description
 * # ConfigService
 * Service in the courseApp.
 */
angular.module('courseApp')
    .service('ConfigService', function (NgTableParams, ATTENDEE_TYPE, CONFIG) {
        return {
            NgTableParams: NgTableParams,
            ATTENDEE_TYPE: ATTENDEE_TYPE,
            CONFIG: CONFIG
        };
    });
